export const STOREFRONT_LABELS_QUERY_PARAM: string = 'storefront_labels';

export const STOREFRONT_LABELS_COOKIE: string = 'storefront_labels';
